module.exports = __webpack_public_path__ + "media/Text_center_low.dc764f1f.mp4";